import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-arrays-sort-mutation',
  slug: 'sort-mutation',
  title: 'The leaderboard that scrambles itself',
  type: 'bug-hunt',
  estSeconds: 300,
  contentVersion: 1,
});
